module.exports = __webpack_public_path__ + "SUBARU-logo.png";